import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, ModelSelect } from 'vue-search-select';
import Multiselect from 'vue-multiselect'

export default {
  name: 'push-center-code',
  components: {
    VueElementLoading,
    BasicSelect,
    ModelSelect,
    Multiselect
  },
  props: [],
  data () {
    return {
      isLoading: false,
      centername:'',
      hubLoading:'',
      cHubid: '',
      hubid: "",
      hubObjData: {
				value: "",
				text: ""
			},
      centernamearr:'',
      hubdetailsarray: [],
      DestHubNameData: [],
      HubNameData: [],
      isArmstrong: false
    }
  },
  computed: {},
  filters: {
  },
  mounted () {
    this.getHubName();
  },
  methods: {
    selectedHub(hubData) {
			this.hubObjData = hubData
			this.hubid = hubData.value;
		},
    pushCenterList() {
      this.isLoading = true
      if (/\r?\n|\r/g.test(this.centername) == true) {
        this.centername = this.centername.replace(/\r?\n| |\r/g, ',');
      }
      this.input =({
        hubId:this.hubid,
        centername:this.centername,
        isArmstrong:this.isArmstrong
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'pushCenterList',
          'data': this.input,
          headers: {
          'authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.isLoading = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
          this.isLoading = false
        })
    },
    onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
            console.log(result);
						return false;
					} else {
						this.pushCenterList();
					}
				}).catch((err) => {
					console.log('errors exist', this.errors);
				});
		},
    resetForm() {
			this.centername = '';
      this.hubid='';
      this.cHubid = '';
      this.hubObjData = {
				value: "",
				text: ""
			};
      this.isArmstrong=false;
      this.$validator.reset()
		},
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          // 'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          this.hubdetailsarray = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/PushCenterCode/PushCenterCode.js